module.exports = __webpack_public_path__ + "static/img/1960_06_HarpersMagazine_TudorFeature_1.66b58ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1960_06_HarpersMagazine_TudorFeature_1.jpg
// module id = kW1X
// module chunks = 0